import AppBarChart from '@/components/AppBarChart';
import useMediaQuery, { mediaQueryPoints } from '@/hooks/useMediaQuery';
import React, { useState } from 'react';
import { Bar } from 'recharts';

function OverviewChart({ dataSource, packageOption, loading, chartMetrics, visibleMetrics }) {
  const isMobile = useMediaQuery(`(max-width: ${mediaQueryPoints.md}px)`);
  return (
    <div
      className={`w-full flex items-center mt-4 gap-4 ${isMobile ? 'h-[400px]' : 'h-[600px] mb-6'}`}
    >
      <AppBarChart
        data={dataSource}
        xAxisLabel="Package"
        yAxisLabel="Register"
        xAxisDataKey="package_code"
        loading={loading}
      >
        {chartMetrics.map((metric) => {
          if (!visibleMetrics.includes(metric.key)) return null;

          if (metric.type === 'bar') {
            return (
              <Bar key={metric.key} dataKey={metric.key} fill={metric.color} name={metric.label} />
            );
          }

          return null;
        })}
      </AppBarChart>
    </div>
  );
}

export default OverviewChart;
